module.exports = __webpack_public_path__ + "img/SV.0865f417.png";